module.exports = __webpack_public_path__ + "static/media/FNEP.c2f76764.png";